import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';
import {LazyLoadImage} from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/bh/empowerment.webp";

function Banner(props) {
    return (
        <div className="enablement p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="">
                                <h2>TekRevol’s Influence: A Top-tier App Development Company in Bahrain</h2>
                            </div>
                            <p>TekRevol has entered Bahrain with unparalleled digital innovations and solutions. We have specialized in different domains of mobile app development Bahrain to offer solutions that will be best fit for your business niche and budget requirements. Proving our credibility in the global market for the past 5 years, we are here to facilitate the rapidly growing market of the GCC religion.</p>
                            <p>We have a dedicated team of app developers in Bahrain who understand and acknowledge the app market and business requirements accordingly. As a result, we come up with robust mobile applications having top-quality features, functions, and integrations that make your app outstanding from the competition.</p> 
                            <Link to="/contact"
                                  className="border_btn dark_btn" aria-label="TekRevol Contact"> Let’s Get Started</Link>
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
                        <LazyLoadImage
                            src={Img}
                            effect="blur" alt="Image" className="img-fluid"
                        />
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;